import { GI18NText } from '~/presentation/common';
import { useTranslation } from 'react-i18next';
import { List, Text } from '@shopify/polaris';
import { ActionTemplate } from '../common';

interface RepublishTemplateItemProps {
  name: string;
  onRepublish: () => void;
}

export const RepublishTemplateItem = ({ name, onRepublish }: RepublishTemplateItemProps) => {
  const { t } = useTranslation();

  return (
    <List.Item>
      <GI18NText
        as="span"
        variant="bodyMd"
        transformers={{
          1: (text) => (
            <Text as="span" fontWeight="semibold" variant="bodyMd">
              {text}
            </Text>
          ),
        }}
      >
        {t('Republish [1]"{{name}}"[].', { name })}
      </GI18NText>{' '}
      <ActionTemplate actionLabel={t('Open page to publish')} onHandleAction={onRepublish} />
    </List.Item>
  );
};
